export default __webpack_public_path__ + "static/media/HN.7608c0ef.svg";